"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFoundPage = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _shared = require("@lachevaliniere/shared");

var _notFoundPageModule = _interopRequireDefault(require("./not-found-page.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFoundPage = function NotFoundPage(_ref) {
  var title = _ref.title,
      text = _ref.text,
      button = _ref.button;
  return /*#__PURE__*/_react.default.createElement(_shared.Section, null, /*#__PURE__*/_react.default.createElement(_shared.Container, null, /*#__PURE__*/_react.default.createElement(_shared.Title, {
    wrapper: "h1"
  }, title), /*#__PURE__*/_react.default.createElement(_shared.Text, null, text), /*#__PURE__*/_react.default.createElement("div", {
    className: _notFoundPageModule.default.button
  }, /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    to: "/"
  }, button))));
};

exports.NotFoundPage = NotFoundPage;
NotFoundPage.propTypes = {
  title: _propTypes.default.string.isRequired,
  text: _propTypes.default.string.isRequired,
  button: _propTypes.default.string.isRequired
};